import React from 'react';
import PropTypes from 'prop-types';
import { asDayMonthYear } from 'utils/date-formatter';
import { MemberPersonalInformation } from './MemberPersonalInformation';

export const MemberContent = (props) => {
  const { Membership } = props;

  return (
    <section>
      <h2>Membership</h2>
      <p className="large">
        Below is your current membership information. To renew your membership, of if you have any
        enquiries regarding the status or renewal of your membership please contact the Membership
        office on <strong>(03) 9281 8453</strong>.
      </p>

      <h3>Membership information</h3>
      {Membership?.map((item, index) => (
        <div className="membership-info-section" key={index}>
          <div className="row">
            <div className="col-xs-6 col-md-2">
              <strong>Membership option</strong>
            </div>
            <div className="col-xs-6 col-md-10">{item.LevelDescription}</div>
          </div>
          <div className="row">
            <div className="col-xs-6 col-md-2">
              <strong>Expiry date</strong>
            </div>
            <div className="col-xs-6 col-md-10">{asDayMonthYear(Date.parse(item.Expiry))}</div>
          </div>
        </div>
      ))}

      <MemberPersonalInformation {...props} />
    </section>
  );
};

MemberContent.propTypes = {
  Membership: PropTypes.array,
};
